var map: CDN.Map.Map;
var vehicleAccordion: CDN.Controls.VehicleAccordion.VehicleAccordion | null = null;
var areaAccordion: CDN.Controls.AreaAccordion.AreaAccordion | null = null;
var mapVehicle: CDN.Map.TestMapVehicle | null = null;
var userToken: string = '';
var products: CDN.API.User.v1.LoginResultProduct[] = [];
var mapLoaded: boolean = false;
var routePanelLoaded: boolean = false;
var routeMarkerClass: string = null;

var mapElement: HTMLElement = document.createElement('div');
var dialogContainer: HTMLElement = document.createElement('div');
var optionsPanel: HTMLElement = document.createElement('div');
var vehAccElement: HTMLElement = document.createElement('div');
var areaAccElement: HTMLElement = document.createElement('div');
var routePanelElement: HTMLElement = document.createElement('div');

const posTypes = {
    16: { type: 'idle' },
    17: { type: 'start', color: 'green' },
    18: { type: 'halfway' },
    20: { type: 'stop', color: 'red' }
};

CDN.requireOnce([
	{ code: CDN.PackageCode.JQuery, },
	{ code: CDN.PackageCode.API_Vehicle_Position_v1, },
	{ code: CDN.PackageCode.Map, },
	{ code: CDN.PackageCode.Control_Angular_Accordion, },
	{ code: CDN.PackageCode.Control_Login, },
	{ code: CDN.PackageCode.Control_IconMenu, },
	{ code: CDN.PackageCode.Bootstrap },
	{ code: CDN.PackageCode.Control_Dialog, },
	{ code: CDN.PackageCode.API_Area_v1, },
	{ code: CDN.PackageCode.Common, }
], () => {
    /*Do our map code here:*/
    let parent = document.getElementsByTagName("body")[0];
    let loginDiv: HTMLElement = document.createElement('div');
    $(loginDiv).addClass('ms-3 p-2');
	parent.appendChild(loginDiv);

	let logoutDiv: HTMLElement = document.createElement('div');
	$('.navbar > .container').append(logoutDiv);

    let baseElement: HTMLElement = document.createElement('div');
    $(baseElement).addClass('d-flex d-none');
    parent.appendChild(baseElement);

    let menuElement: HTMLElement = document.createElement('div');
    $(menuElement).addClass('ms-2 dark');
    $(menuElement).css('width', '80px');
    $(menuElement).css('z-index', '9999');
    baseElement.appendChild(menuElement);

	var treeViewElement: HTMLElement = document.createElement('div');
    $(treeViewElement).addClass('px-1');
    $(treeViewElement).css('width', '300px');
    baseElement.appendChild(treeViewElement);

	$(dialogContainer).css('width', '250px');
	$(dialogContainer).addClass('hide');
	baseElement.appendChild(dialogContainer);

    $(mapElement).addClass('flex-grow-1 px-1');
    //$(mapElement).css("height", "540px");
    baseElement.appendChild(mapElement);

    $(optionsPanel).addClass('p-1 bg-dark rounded mb-1');
	$(treeViewElement).append(optionsPanel);

    $(optionsPanel).append("<div class='text-light display-selected-menu'></div>");

    $(vehAccElement).addClass('accordion-component d-none');
	$(treeViewElement).append(vehAccElement);

    $(areaAccElement).addClass('accordion-component d-none');
	$(treeViewElement).append(areaAccElement);

	$(routePanelElement).addClass('route-panel d-none');
	$(treeViewElement).append(routePanelElement);

	let groups: CDN.Controls.IconMenuTypes.ItemGroupOptions[] = [
		{
			name: "main",
			selectionMode: CDN.Controls.IconMenuTypes.SelectionMode.SingleOrNone,
			items: [
				{ text: "Vehicles", icon: { type: "material-symbol", symbol: "local_shipping" }, afterSelectionAsync: async (selected) => { showAccordionAsync(vehAccElement, 'vehicles', selected); }, },
				{ text: "Areas", icon: { type: "material-symbol", symbol: "format_shapes" }, afterSelectionAsync: async (selected) => { showAccordionAsync(areaAccElement, 'areas', selected); }, },
				{ text: "Route", icon: { type: "material-symbol", symbol: "route" }, afterSelectionAsync: async (selected) => { showRouteAsync(); }, },
			],
		}
	];

	let menu = new CDN.Controls.IconMenu(menuElement, {
		direction: CDN.Controls.IconMenuTypes.Direction.Vertical,
		groups: groups
	});

	var login: CDN.Controls.Login = new CDN.Controls.Login(loginDiv, {
		onError: (err) => {
			console.error(err);
		},
		onLogin: async (result) => {
			if (result.UserToken == null) {
				console.error('Invalid User Token');
				return;
			}
			userToken = result.UserToken;
			products = result.products;

			sessionStorage.setItem('userToken', userToken);
			sessionStorage.setItem('products', JSON.stringify(products));

			login.hide();
			$(loginDiv).addClass('d-none');
			$(baseElement).removeClass('d-none');
			$(logoutDiv).removeClass('d-none');

			await showAccordionAsync(areaAccElement, 'areas', false);
			initializeMap(async () => {});
			menu.selectAsync({
				group: 0,
				item: 2
			});
		}
	});
	login.hide();

	var $btnLogout: JQuery = $(`<button>logout</button>`);
	$(logoutDiv).append($btnLogout);
	$(logoutDiv).addClass('d-none');
	$btnLogout.click((e) => {
		e.stopPropagation();
		e.preventDefault();

		$(this).prop('disabled', true);
		sessionStorage.setItem('userToken', "");
		sessionStorage.setItem('products', "");

		$(loginDiv).removeClass('d-none');
		login.show();
		$(baseElement).addClass('d-none');
		$(logoutDiv).addClass('d-none');
		$(this).prop('disabled', false);
		location.reload();
	});

	if (sessionStorage.getItem('userToken') != null && sessionStorage.getItem('userToken') != ""
		&& sessionStorage.getItem('products') != null && sessionStorage.getItem('products') != "") {
		userToken = sessionStorage.getItem('userToken');
		products = JSON.parse(sessionStorage.getItem('products'));

		$(loginDiv).addClass('d-none');
		$(baseElement).removeClass('d-none');
		$(logoutDiv).removeClass('d-none');

		initializeMap(async () => { });
		menu.selectAsync({
			group: 0,
			item: 2
		});
	} else {
		/* show login */
		login.show();
		$(loginDiv).removeClass('d-none');
		$(baseElement).addClass('d-none');
	}

    $('#newLayer').click(function () {
        resetForm();
        $('#addLayervehicleAccordion').removeClass('d-none');
        $('#sourceList, #sourceActionvehicleAccordion').addClass('d-none');
    });

    $('#loadAPIData').click(function () {
        if (userToken == '') {
            alert('Invalid user token');
            return;
        }
        let type = $('#apiRequestType').val();
        loadAPIDataAsync(userToken, type)
        .then((result) => {
        });
    });

    $('#back, #back1').click(function () {
        $('#sourceList').removeClass('d-none');
        $('#addLayervehicleAccordion, #sourceActionvehicleAccordion').addClass('d-none');
    });

    $('#sourceList').on('click', '.src-layer', function (e) {
        e.preventDefault();
        e.stopPropagation();
        let playAction = $(this).data('playAction');
        if (!playAction) {
            return false;
        }
        let srcId = $(this).data('srcId');
        $('#actionSrcId').val(srcId);

        $('#sourceActionvehicleAccordion').removeClass('d-none');
        $('#addLayervehicleAccordion, #sourceList').addClass('d-none');
    });

    $('#addLayer').click(function (e) {
        e.preventDefault();
        let points = JSON.parse($('#sourceData').val());
        let color = $('#layerColor').val();
        let lineColor = $('#lineColor').val();
        let requestLayer = $('#srcLayer').val();
        if (requestLayer == 'heat-map') {
            color = '#31e91b';
        }
        appendToMap(requestLayer, points, true, color, lineColor);
    });

    $('#srcLayer').on('change', function (e) {
        if ($(this).val() == 'heat-map') {
            $('#colorsRow').addClass('d-none');
        } else {
            $('#colorsRow').removeClass('d-none');
        }
    });

    $('#sourceList').on('click', '.remove-layer', function (e) {
        e.preventDefault();
        e.stopPropagation();
        let sources = $(this).data('srcId');
        for (let i in sources) {
            let srcId = sources[i];
            map.removeSource(srcId);
        }
        $(this).parent().remove();

        let element = $('#sourceList .avail-sources .src-layer').last();
        let source = null;
        if (element.length > 0) {
            let srcId = $(element).data('srcId');
            source = map.getSource(srcId);
        }
        if (source != null && source.hasOwnProperty('data')) {
            map.setCenter(5, source);
        } else {
            map.setCenter();
        }
    });

    $('#sourceActionvehicleAccordion').on('click', '#replayJourney', function (e) {
        let srcId = $('#actionSrcId').val();
        map.replayJourney(srcId);
    });

    $('#sourceActionvehicleAccordion').on('click', '#pauseJourney', function (e) {
        let srcId = $('#actionSrcId').val();
        $(this).addClass('d-none');
        $('#sourceActionvehicleAccordion #playJourney').removeClass('d-none');
        map.pauseJourney(srcId);
    });

    $('#sourceActionvehicleAccordion').on('click', '#playJourney', function (e) {
        let srcId = $('#actionSrcId').val();
        $(this).addClass('d-none');
        $('#sourceActionvehicleAccordion #pauseJourney').removeClass('d-none');
        map.playJourney(srcId);
    });

    $('#sourceActionvehicleAccordion').on('click', '#resetJourney', function (e) {
        let srcId = $('#actionSrcId').val();
        map.resetJourney(srcId);
    });

    /*
    $('.cdn-map-container').find('.maplibregl-ctrl-mapstyle').first()[0].addEventListener('click', function (e) {
        resetFormLayers();
    });
    $('.cdn-map-container').find('.maplibregl-ctrl-tomstyle').first()[0].addEventListener('click', function (e) {
        resetFormLayers();
    });
    $('.cdn-map-container').find('.maplibregl-ctrl-satstyle').first()[0].addEventListener('click', function (e) {
        resetFormLayers();
    });
    */
});

async function showAccordionAsync(element: HTMLElement, type: 'vehicles' | 'areas', selected: boolean) {
    let text: string = (!selected) ? '<i>Select an option from the menu.</i>' : type.charAt(0).toUpperCase() + type.slice(1);
    $('.display-selected-menu').html(text);
	$('.accordion-component').addClass('d-none');
	$('.route-panel').addClass('d-none');
	if (!selected) {
		return;
	}
	$(element).removeClass('d-none');
	if (!mapLoaded) {
		let callBack: () => {} = async () => {
			if (type == 'vehicles' && vehicleAccordion === null) {
				await initializeVehicleAccordionAsync();
			} else if (type == 'areas' && areaAccordion === null) {
				await initializeAreaAccordionAsync();
			}
		};
		initializeMap(callBack);
	} else {
		if (type == 'vehicles' && vehicleAccordion === null) {
			await initializeVehicleAccordionAsync();
		} else if (type == 'areas' && areaAccordion === null) {
			await initializeAreaAccordionAsync();
		}
	}
}

function setupRoutePanel() {
	let info = '# Currently OSM routing has been implemented for Mauritius. While testing, please pan and zoom manually on Mauritius and use RASTER map layer. Auto-pan and Auto-zoom has been disabled in order to test multiple routes at the same location.';
	$(routePanelElement).append('<p class="text-warning bg-dark p-2 rounded fst-italic fw-light">'+ info +'</p>');

	let lblPanel: HTMLElement = document.createElement('div');
	$(routePanelElement).append(lblPanel);

	let label: HTMLLabelElement = document.createElement('label');
	label.className = "form-label fw-bold me-2";
	label.innerHTML = 'Points (Lon,Lat)';
	$(lblPanel).append(label);

	let btn2: HTMLElement = document.createElement('button');
	btn2.className = "m-1 p-0 badge rounded-pill bg-danger border border-danger border-1 text-white material-symbols-outlined clear-route-input float-end";
	btn2.innerHTML = "clear";
	$(lblPanel).append(btn2);

	let btn1: HTMLElement = document.createElement('button');
	btn1.className = "m-1 p-0 badge rounded-pill bg-light text-dark border border-secondary border-1 material-symbols-outlined route-location-marker route-input-source float-end";
	btn1.innerHTML = "location_on";
	$(lblPanel).append(btn1);

	let txtArea: HTMLTextAreaElement = document.createElement('textarea');
	txtArea.rows = 7;
	txtArea.cols = 10;
	txtArea.className = "form-control route-input route-input-source";
	$(routePanelElement).append(txtArea);

	let ovlabel: HTMLLabelElement = document.createElement('label');
	ovlabel.className = "form-label mb-1";
	ovlabel.innerHTML = 'Overview';
	$(routePanelElement).append(ovlabel);

	let selectInput: HTMLSelectElement = document.createElement('select');
	selectInput.className = "form-select form-select-sm route-input route-input-overview mb-3";

	let selectOption2: HTMLOptionElement = document.createElement('option');
	selectOption2.value = 'full';
	selectOption2.innerHTML = 'Full';
	selectInput.add(selectOption2);

	let selectOption1: HTMLOptionElement = document.createElement('option');
	selectOption1.value = 'simplified';
	selectOption1.innerHTML = 'Simplified';
	selectInput.add(selectOption1);

	$(routePanelElement).append(selectInput);

	let loadLabel: HTMLLabelElement = document.createElement('label');
	loadLabel.className = "form-label mb-1";
	loadLabel.innerHTML = 'Load From';
	$(routePanelElement).append(loadLabel);

	let selectInputLoad: HTMLSelectElement = document.createElement('select');
	selectInputLoad.className = "form-select form-select-sm route-input route-input-loadfrom mb-3";

	let selectOpt1: HTMLOptionElement = document.createElement('option');
	selectOpt1.value = 'osrm';
	selectOpt1.innerHTML = 'OSRM';
	selectInputLoad.add(selectOpt1);

	let selectOpt2: HTMLOptionElement = document.createElement('option');
	selectOpt2.value = 'local';
	selectOpt2.innerHTML = 'Local';
	selectInputLoad.add(selectOpt2);

	let selectOpt3: HTMLOptionElement = document.createElement('option');
	selectOpt3.value = 'mapserver';
	selectOpt3.innerHTML = 'Map Server';
	selectInputLoad.add(selectOpt3);

	$(routePanelElement).append(selectInputLoad);

	let input: HTMLInputElement = document.createElement('input');
	input.type = 'text';
	input.className = "form-control form-control-sm vehicle-product-id mb-3 d-none";
	input.placeholder = 'Product ID';
	$(routePanelElement).append(input);

	let input1: HTMLInputElement = document.createElement('input');
	input1.type = 'text';
	input1.className = "form-control form-control-sm vehicle-id mb-3 d-none";
	input1.placeholder = 'Vehicle ID';
	$(routePanelElement).append(input1);

	let input2: HTMLInputElement = document.createElement('input');
	input2.type = 'text';
	input2.className = "form-control form-control-sm vehicle-trip-id mb-3 d-none";
	input2.placeholder = 'Trip ID';
	$(routePanelElement).append(input2);

	let button: HTMLButtonElement = document.createElement('button');
	button.className = "btn btn-primary btn-sm route-submit  mb-5";
	button.innerHTML = "Load Route";
	$(routePanelElement).append(button);
	$(routePanelElement).append('&nbsp;');

	let clearButton: HTMLButtonElement = document.createElement('button');
	clearButton.className = "btn btn-warning btn-sm route-clear  mb-5";
	clearButton.innerHTML = "Clear";
	$(routePanelElement).append(clearButton);

	$('.route-panel').on('click', '.route-location-marker', async (e: JQueryMouseEventObject) => {
		e.preventDefault;
		if (routeMarkerClass != null && map.marker != null) {
			map.marker.off('dragend', () => {
				let lngLat = map.marker.getLngLat();
				let curVal: string = $('.route-input.' + routeMarkerClass).val();
				curVal += (curVal != '') ? ';' : '';
				$('.route-input.' + routeMarkerClass).val(curVal + lngLat.lng + ',' + lngLat.lat);
			});
		}
		let className: string = e.target.className;
		className = className.split(' ').join('.');
		if ($('.route-location-marker.route-input-source').hasClass('bg-primary')) {
			/* selected item is clicked - deselect and remove marker */
			$('.route-location-marker.route-input-source').removeClass('bg-primary text-white').addClass('bg-light text-dark');
			map.removeMarker();
			routeMarkerClass = null;
			return;
		}
		routeMarkerClass = 'route-input-source';
		$('.route-location-marker.route-input-source').removeClass('bg-light text-dark').addClass('bg-primary text-white');

		map.addMarker();
		map.marker.on('dragend', () => {
			let lngLat = map.marker.getLngLat();
			let curVal: string = $('.route-input.' + routeMarkerClass).val();
			curVal += (curVal != '') ? ';' : '';
			$('.route-input.' + routeMarkerClass).val(curVal + lngLat.lng + ',' + lngLat.lat);
		});
	});
	$('.route-panel .clear-route-input').click(async (e) => {
		e.preventDefault;
		$('.route-input.route-input-source').val('');
	});
	$('.route-panel button.route-submit').click(async (e) => {
		e.preventDefault;
		/*
		let productId: CDN.Common.ProductId = $('.vehicle-product-id').val();
		let vehicleId: string = $('.vehicle-id').val();
		let tripId: string = $('.vehicle-trip-id').val();
		if (vehicleId != '' && tripId != '' && mapVehicle != null) {
			let data: CDN.Controls.VehicleAccordion.VehicleData = {
				vehicleId: Number(vehicleId),
				tripId: Number(tripId),
				productId: productId
			}
			await mapVehicle.loadNavigationAsync(data);
		}*/
		let srcPoints: string = $('.route-input.route-input-source').val();
		if (srcPoints == '') {
			$('.route-input.route-input-source').focus();
			return;
		}
		let points: string[] = [];
		for (let point of srcPoints.split(';')) {
			points.push(point.split(',').map(x => x.trim()).join(','));
		}
		let overview: 'simplified' | 'full' = $('.route-input.route-input-overview').val();
		let loadFrom: 'osrm' | 'local' = $('.route-input.route-input-loadfrom').val();
		await drawRouteAsync(points, overview, loadFrom);
	});
	$('.route-panel button.route-clear').click(async (e) => {
		e.preventDefault;
		map.removeMarker();
		map.clear();
	});
	routePanelLoaded = true;
}

async function showRouteAsync() {
	$('.display-selected-menu').html('Route Panel');
	$('.accordion-component').addClass('d-none');
	$('.route-panel').removeClass('d-none');
	if (!routePanelLoaded) {
		setupRoutePanel();
	}
}

async function drawRouteAsync(points: string[], overview: 'simplified' | 'full' = 'simplified', loadFrom: 'osrm' | 'local' | 'mapserver') {
	let sourceId: string = 'testMapRoute' + (new Date().getTime());
	/*if (map.hasSource(sourceId + '_line')) {
		map.removeSource(sourceId + '_line');
	}
	if (map.hasSource(sourceId)) {
		map.removeSource(sourceId);
	}*/
	let routeSegments: CDN.API.Area.v1.PointSegment[] = await CDN.API.Area.v1.getRouteAsync(
		{ userToken: userToken, productId: products[0].productID },
		points,
		overview,
		loadFrom
	);

	let options: CDN.Map.FeatureOptions[] = [];
	for (let key in routeSegments) {
		let routeSegment: CDN.API.Area.v1.PointSegment = routeSegments[key];
		let posType = (key == '0') ? '17' : '18';
		if (routeSegments[Number(key) + 1] == undefined) {
			/* last point */
			posType = '20';
		}
		let position: CDN.Map.FeatureOptions = {
			title: "",
			position: [routeSegment.Lon, routeSegment.Lat],
			direction: routeSegment.Direction,
			posType: posType
		};
		options.push(position);
	}
	let lineColor: string = (loadFrom == "local") ? '#006796' : '#860000';
	lineColor = (loadFrom == "mapserver") ? '#1fff00' : lineColor;
	if (options.length > 0) {
		await appendToMap('arrow-line', options, true, '#007fd9', lineColor, sourceId);
	}
}

function initializeMap(callBack: () => {}) {
	if (mapLoaded) {
		return;
	}
	map = new CDN.Map.Map(mapElement, {drawControl: true, onLoad: callBack});
	mapLoaded = true;
}

async function initializeVehicleAccordionAsync() {
	/* set map vehicle */
	mapVehicle = new CDN.Map.TestMapVehicle(map, userToken, products);
	let actionParams: CDN.Controls.VehicleAccordion.ActionParams = {
		vehicleParams: {
			actionParams: (data: CDN.Controls.VehicleAccordion.VehicleData) => {
				return [
					{
						name: 'location',
						iconParameters: {
							name: (status: CDN.Controls.Accordion.ActionStatus): string => {
								if (status == CDN.Controls.Accordion.ActionStatus.On) {
									return 'location_on';
								}
								return 'location_off';
							},
							type: 'material-icon',
							title: (status: CDN.Controls.Accordion.ActionStatus): string => {
								if (status == CDN.Controls.Accordion.ActionStatus.On) {
									return 'Clear current location';
								} else if (status == CDN.Controls.Accordion.ActionStatus.Busy) {
									return 'Loading current location';
								}
								return 'Load current location';
							},
							style: (status: CDN.Controls.Accordion.ActionStatus): CDN.Controls.Accordion.Style => {
								let color: string = '#b9a690';
								if (status == CDN.Controls.Accordion.ActionStatus.On) {
									color = '#c30303';
								} else if (status == CDN.Controls.Accordion.ActionStatus.Busy) {
									color = '#ff4700';
								}
								return { 'color': color, 'font-size': '20px', 'padding': '3px 0px 0px 2px' };
							}
						},
						spinner: true,
						onClickAsync: async () => {
							return await mapVehicle.loadLocationAsync(data);
						}
					}
				];
			}
		},
		tripParams: {
			onClickAsync: async (data: CDN.Controls.VehicleAccordion.VehicleData) => {
				return await mapVehicle.loadNavigationAsync(data);
			},
			actionParams: (data: CDN.Controls.VehicleAccordion.VehicleData) => {
				return [
					{
						name: 'navigation',
						iconParameters: {
							name: 'navigation',
							type: 'material-icon',
							title: (status: CDN.Controls.Accordion.ActionStatus): string => {
								if (status == CDN.Controls.Accordion.ActionStatus.On) {
									return 'Clear';
								} else if (status == CDN.Controls.Accordion.ActionStatus.Busy) {
									return 'Loading';
								}
								return 'Load';
							},
							style: (status: CDN.Controls.Accordion.ActionStatus): CDN.Controls.Accordion.Style => {
								if (status == CDN.Controls.Accordion.ActionStatus.On) {
									return { color: 'blue' };
								}
								return { color: '#b7b7fb', padding: '0px 0px 0px 2px' };
							},
							class: ['navigation', 'navigation-icon', 'cursor-pointer']
						},
						spinner: true,
						onClickAsync: async () => {
							return await mapVehicle.loadNavigationAsync(data);
						}
					}
				];
			}
		}
	};
	vehicleAccordion = new CDN.Controls.VehicleAccordion.VehicleAccordion(vehAccElement, userToken, products, actionParams);
	/* set bulk actions */
	let bulkActions: CDN.Controls.Accordion.BulkAction[] = [
		{
			name: "Show all checked",
			properties: { type: "stroked-button", color: "primary" },
			onClickAsync: async (nodes: any[]) => {
				let tasks: Promise<boolean>[] = [];
				for (let node of nodes) {
					if (node?.parameters && node.parameters?.data) {
						let params: CDN.Controls.VehicleAccordion.VehicleData = {
							vehicleId: node.parameters.data.vehicleId,
							tripId: node.parameters.data.tripId,
							productId: node.parameters.data.productId
						}
						tasks.push(mapVehicle.loadNavigationAsync(params)
							.then((response: CDN.Controls.Accordion.ActionClickResponse) => {
								return response.success;
							})
						);
					}
				}
				await Promise.all(tasks);
				return true;
			},
			spinner: true
		},
		{
			name: "Clear All",
			properties: { type: "stroked-button", color: "warn" },
			onClickAsync: async (nodes: any[]) => {
				map.clear();
				return true;
			}
		}
	];
	vehicleAccordion.bulkActions = bulkActions;
}

async function initializeAreaAccordionAsync() {
	/* set draw */
	let draw: CDN.Map.DrawControl = map.draw;
	/* set draw area */
	let testPolygon: CDN.Map.TestDrawPolygon;
	/* set draw route */
	let testDirectedLine: CDN.Map.TestDrawDirectedLine = new CDN.Map.TestDrawDirectedLine(draw, userToken, products, dialogContainer);

	let nodeActions: CDN.Controls.AreaAccordion.NodeActions = {
		areaActions: {
			actionParameters: (data: CDN.Controls.AreaAccordion.PolygonData) => {
				return [
					{
						name: 'area',
						iconParameters: {
							name: (status: CDN.Controls.Accordion.ActionStatus): string => {
								if (status == CDN.Controls.Accordion.ActionStatus.On) {
									return 'visibility';
								}
								return 'visibility_off';
							},
							type: 'material-icon',
							title: (status: CDN.Controls.Accordion.ActionStatus): string => {
								if (status == CDN.Controls.Accordion.ActionStatus.On) {
									return 'Clear area';
								} else if (status == CDN.Controls.Accordion.ActionStatus.Busy) {
									return 'Loading area';
								}
								return 'Load area';
							},
							style: (status: CDN.Controls.Accordion.ActionStatus): CDN.Controls.Accordion.Style => {
								let color: string = '#a4a4a4';
								if (status == CDN.Controls.Accordion.ActionStatus.On) {
									color = '#161616';
								} else if (status == CDN.Controls.Accordion.ActionStatus.Busy) {
									color = '#787878';
								}
								return { 'color': color, 'font-size': '20px', 'padding': '4px 0px 0px 3px' };
							}
						},
						spinner: true,
						onClickAsync: async () => {
							return await testPolygon.loadMapAreaAsync(data, false, true);
						}
					},
					{
						name: 'edit',
						iconParameters: {
							name: (status: CDN.Controls.Accordion.ActionStatus): string => {
								if (status == CDN.Controls.Accordion.ActionStatus.On) {
									return 'layers_clear';
								}
								return 'edit';
							},
							type: 'material-icon',
							title: (status: CDN.Controls.Accordion.ActionStatus): string => {
								if (status == CDN.Controls.Accordion.ActionStatus.On) {
									return 'Clear Area';
								} else if (status == CDN.Controls.Accordion.ActionStatus.Busy) {
									return 'Loading Area';
								}
								return 'Edit ' + data.name;
							},
							style: (status: CDN.Controls.Accordion.ActionStatus): CDN.Controls.Accordion.Style => {
								let color: string = '#68b6e2';
								if (status == CDN.Controls.Accordion.ActionStatus.On) {
									color = '#f65a07';
								} else if (status == CDN.Controls.Accordion.ActionStatus.Busy) {
									color = '#787878';
								}
								return { 'color': color, 'font-size': '20px', 'padding': '3px 0px 0px 3px' };
							}
						},
						displayOnNodeHover: true,
						onClickAsync: async () => {
							return await testPolygon.loadMapAreaAsync(data, true);
						}
					}
				];
			},
			editCallBackAsync: async (data: CDN.Controls.AreaAccordion.PolygonData, text: string) => {
				return await areaAccordion.updateAreaNameAsync(data, text);
			}
		},
		routeActions: {
			actionParameters: (data: CDN.Controls.AreaAccordion.RouteData) => {
				return [
					{
						name: 'route',
						iconParameters: {
							name: (status: CDN.Controls.Accordion.ActionStatus): string => {
								if (status == CDN.Controls.Accordion.ActionStatus.On) {
									return 'visibility';
								}
								return 'visibility_off';
							},
							type: 'material-icon',
							title: (status: CDN.Controls.Accordion.ActionStatus): string => {
								if (status == CDN.Controls.Accordion.ActionStatus.On) {
									return 'Clear Route';
								} else if (status == CDN.Controls.Accordion.ActionStatus.Busy) {
									return 'Loading Route';
								}
								return 'Load Route';
							},
							style: (status: CDN.Controls.Accordion.ActionStatus): CDN.Controls.Accordion.Style => {
								let color: string = '#a4a4a4';
								if (status == CDN.Controls.Accordion.ActionStatus.On) {
									color = '#161616';
								} else if (status == CDN.Controls.Accordion.ActionStatus.Busy) {
									color = '#787878';
								}
								return { 'color': color, 'font-size': '20px', 'padding': '4px 0px 0px 3px' };
							}
						},
						spinner: true,
						onClickAsync: async () => {
							return await testDirectedLine.loadRouteAsync(data);
						}
					}
				];
			},
			editCallBackAsync: async (data: CDN.Controls.AreaAccordion.RouteData, text: string) => {
				return await this.UpdateTimedRouteNameAsync(data, text);
			}
		}
	}
	/* set polygon parameters to the draw area */
	let polygonParams: CDN.Map.PolygonParameters = {
		saveCallBack: async () => {
			/* clear the accordion and reload the nodes */
			areaAccordion.reloadNodesAsync(nodeActions);
		}
	}
	testPolygon = new CDN.Map.TestDrawPolygon(draw, userToken, products, dialogContainer, polygonParams);
	/* initialize area accordion */
	areaAccordion = new CDN.Controls.AreaAccordion.AreaAccordion(areaAccElement, userToken, products, nodeActions);

	/* set bulk actions */
	let actions: CDN.Controls.Accordion.BulkAction[] = [{
		name: "Show all checked areas",
		properties: { type: "stroked-button", color: "primary" },
		onClickAsync: async (nodes: any[]) => {
			let tasks: Promise<boolean>[] = [];
			for (let node of nodes) {
				if (node.parameters?.data) {
					tasks.push(testPolygon.loadMapAreaAsync(node.parameters.data)
						.then((response: CDN.Controls.Accordion.ActionClickResponse) => {
							return response.success;
						})
					);
				}
			}
			await Promise.all(tasks);
			return true;
		},
		spinner: true
	},
	{
		name: "Clear All",
		properties: { type: "stroked-button", color: "warn" },
		onClickAsync: async (nodes: any[]) => {
			testPolygon.clear();
			testDirectedLine.clear();
			return true;
		}
	}];
	areaAccordion.bulkActions = actions;
}

function resetForm() {
    $('#sourceData').val('');
    $('#srcLayer').val('symbol');
    $('#layerColor').val('#ff0000');
}

function resetFormLayers() {
    $('#sourceList .avail-sources .src-layer').each(function () {
        let srcId = $(this).data('srcId');
        if (!map.hasSource(srcId)) {
            $(this).remove();
        }
    });
}

async function loadAPIDataAsync(userToken: string, type: string, vehicleId: number = 18567, tripId: number = 44838.5770370395): Promise<boolean> {
    let availableTypes: string[] = ['heat-map'];
    if (availableTypes.indexOf(type) < 0) {
        return false;
    }
	$('#loadAPIData').addClass('disabled');
	$('#loadAPIData .display-text').text('Loading ');
	$('#loadAPIData .spinner-border').removeClass('d-none');
	if (type == 'heat-map') {
		let date = '2022-10-13 08:30:00';
		let tasks: Promise<CDN.Map.DataPoint[]>[] = [];
		for (let prod of products) {
			tasks.push(CDN.API.Vehicle.Position.v1.getAllVehiclePositionsAsync({ productId: prod.productID, userToken: userToken }, prod.productID, date)
				.then((positions: CDN.API.Vehicle.Position.v1.VehiclePosition[]) => {
					let parsedData: CDN.Map.DataPoint[] = [];
					for (let position of positions) {
						let point: CDN.Map.DataPoint = {
							position: {
								longitude: position.Position[0],
								latitude: position.Position[1]
							},
							dateTime: position.DateTime,
							data: {
								title: position.Registration,
								vehilcleID: position.VehLst_ID,
								type: 'position'
							}
						};
						parsedData.push(point);
					}
					return parsedData;
				})
			);
		}
		let results: CDN.Map.DataPoint[][] = await Promise.all(tasks);
		let featureOptions: CDN.Map.FeatureOptions[] = [];
		for (let result of results) {
			var preparedData: CDN.Map.FeatureOptions[] = [];
			var prevLng = 0;
			var prevLat = 0;
			for (let data of result) {
				if (data.position.longitude == 0 || data.position.latitude == 0) {
					continue;
				}
				if (data.position.longitude == prevLng && data.position.latitude == prevLat) {
					/* duplicate data */
					continue;
				}
				let position: CDN.Map.FeatureOptions = {
					'title': data.data?.title,
					'position': [data.position.longitude, data.position.latitude],
					'dataType': data.data.type,
					'data': {
						'vehilcleID': data.data?.vehilcleID
					}
				};
				prevLng = data.position.longitude;
				prevLat = data.position.latitude;
				preparedData.push(position);
			}
			featureOptions = featureOptions.concat(preparedData);
		}
		appendToMap('heat-map', featureOptions, true, '#31e91b', '#484848', null, false);
		$('#loadAPIData').removeClass('disabled');
		$('#loadAPIData .display-text').text('Load from API ');
		$('#loadAPIData .spinner-border').addClass('d-none');
		return true;
	}
}

function appendToMap(requestLayer: string, points: CDN.Map.FeatureOptions[], overlap: boolean = false, color: string = '#007fd9', lineColor: string = '#484848', sourceId: string = null, needsPos: boolean = true, mapOptions?: CDN.Map.LayerOptions) {
    if (sourceId == null) {
        sourceId = 'map_source_' + new Date().getTime();
    }
    let coordinates: number[][] = [];
    let collection = new CDN.Map.FeatureCollection();
    for (let idx in points) {
        let point = points[idx];
        let posType: any;
        if (posTypes.hasOwnProperty(point.posType)) {
            posType = posTypes[point.posType];
        }
        point['color'] = color;
        point['lineColor'] = lineColor;
        point['radius'] = 5;
        if (needsPos) {
            point['color'] = posType?.color ?? color;
            point['posType'] = posType?.type ?? '';
        }
        if (requestLayer == 'arrow' || requestLayer == 'arrow-line' || requestLayer == 'circle' || requestLayer == 'heat-map') {
            if (requestLayer == 'heat-map') {
                point['radius'] = 6;
            }
            collection.addFeature(new CDN.Map.GeoJsonFeature({ type: 'Point', coordinates: point.position }, point));
        }
        coordinates.push(point.position);
    }

    let sources = [];
    let playAction = false;
    let i = 1;
    if (requestLayer == 'arrow' || requestLayer == 'arrow-line' || requestLayer == 'pin') {
        /* prepare arrow layer */
        let source = new CDN.Map.GeoJsonSource(collection);
        let srcId = sourceId;
        let options: CDN.Map.LayerOptions = { overlap: overlap };
        let layerId = srcId + '_layer';
        if (mapOptions) {
            options = $.extend(options, mapOptions);
        }
        map.addLayerAsync(source, new CDN.Map.SymbolLayer(layerId, srcId, options))
        .then((result) => {
            if (map.hasSource(srcId)) {
                //map.setCenter(12, source);
                sources.push(srcId);
                playAction = true;
            }
            map.movePinLayer();
        });
        i++;
    }

    if (requestLayer == 'line' || requestLayer == 'arrow-line') {
        /* prepare line layer */
        if (lineColor === undefined) {
            lineColor = color;
        }
        let feature = new CDN.Map.GeoJsonFeature({ type: 'LineString', coordinates: coordinates }, { lineColor: lineColor });
        let source = new CDN.Map.GeoJsonSource(feature);
        let srcId = sourceId;
        if (requestLayer == 'arrow-line') {
            srcId = sourceId + '_line';
        }
        map.addLayerAsync(source, new CDN.Map.LineLayer(srcId + '_layer', srcId))
        .then((result) => {
            if (map.hasSource(srcId)) {
                //map.setCenter(12, source);
                sources.push(srcId);
                if (requestLayer == 'arrow-line') {
                    map.moveLayer(`${sourceId}_layer`);
                }
            }
            map.movePinLayer();
        });
        i++;
    }

    if (requestLayer == 'heat-map') {
        /* prepare heat map layer */
        let source = new CDN.Map.GeoJsonSource(collection);
        let srcId = sourceId;
        map.addLayerAsync(source, new CDN.Map.HeatMapLayer(srcId + '_layer', srcId))
        .then((result) => {
            if (!map.hasSource(srcId)) {
                return;
            }
            map.addLayerAsync(source, new CDN.Map.CircleLayer(srcId + '_layer2', srcId, {minZoom: 7, opacity: 0.7}))
            .then((result) => {
                if (!map.hasSource(srcId)) {
                    return;
                }
                map.setCenter(4, source);
                sources.push(srcId);
                map.movePinLayer();
            });
        });
        i++;
    }

    if (requestLayer == 'circle') {
        /* prepare circle layer */
        let source = new CDN.Map.GeoJsonSource(collection);
        let srcId = sourceId;
        map.addLayerAsync(source, new CDN.Map.CircleLayer(srcId + '_layer', srcId, mapOptions))
        .then((result) => {
            if (map.hasSource(srcId)) {
                map.setCenter(5, source);
                sources.push(srcId);
                playAction = true;
            }
            map.movePinLayer();
        });
        i++;
    }

    /* add polygon layer */
    let polygonSrc = null;
    if (requestLayer == 'polygon-line' || requestLayer == 'polygon-line-fill') {
        /* prepare polygon-line layer */
        let polyFeature = new CDN.Map.GeoJsonFeature({ type: 'Polygon', coordinates: [coordinates] }, { color: color, lineColor: lineColor });
        polygonSrc = new CDN.Map.GeoJsonSource(polyFeature);
        let srcId = sourceId;
        map.addLayerAsync(polygonSrc, new CDN.Map.LineLayer(srcId + '_layer1', srcId))
        .then((result) => {
            if (map.hasSource(srcId)) {
                map.setCenter(12, polygonSrc);
                sources.push(srcId);
            }
            map.movePinLayer();
        });
        i++;
    }

    if (requestLayer == 'polygon-fill' || requestLayer == 'polygon-line-fill') {
        /* prepare polygon-fill layer */
        if (polygonSrc === null) {
            let polyFeature = new CDN.Map.GeoJsonFeature({ type: 'Polygon', coordinates: [coordinates] }, { color: color, lineColor: lineColor });
            polygonSrc = new CDN.Map.GeoJsonSource(polyFeature);
        }
        let srcId = sourceId;
        if (requestLayer == 'polygon-line-fill') {
            srcId = sourceId + '_fill';
        }
        map.addLayerAsync(polygonSrc, new CDN.Map.FillLayer(srcId + '_layer2', srcId))
        .then((result) => {
            if (map.hasSource(srcId)) {
                map.setCenter(12, polygonSrc);
                sources.push(srcId);
            }
            map.movePinLayer();
        });
        i++;
    }
    let element = $('#sourceList .avail-sources .proto').clone();
    element.removeClass('proto d-none').addClass('src-layer');
    element.data('srcId', sourceId);
    element.data('playAction', playAction);
    $('.popup-square', element).css('background', color);
    $('.display-text', element).text(sourceId + ' - ' + $('#srcLayer').val());
    $('.btn.remove-layer', element).data('srcId', sources);
    $('#sourceList .avail-sources').append(element);

    $('#sourceList').removeClass('d-none');
    $('#addLayervehicleAccordion, #sourceActionvehicleAccordion').addClass('d-none');
}

function resetDialogContainer() {
	$(dialogContainer).empty();
	showDialogContainer();
}

function showDialogContainer() {
	$(dialogContainer).removeClass('hide');
}

function hideDialogContainer() {
	$(dialogContainer).addClass('hide');
}
